import * as _4 from 'lodash4';
export interface ISector {
  sectorClipClass: string;
  targetClipClass: string;
  sectorRotation: number;
  targetRotation: number;
  color: string;
}

export class TestScoresGraph {
  section: any;
  nk: string;
  graph: any;
  sectors: ISector[];
  messageConditions: Record<string, string>;
  constructor(private phxFeatureConfiguration: any) {}

  $onInit(): void {
    this.sectors = this.initializeSectors();
    this.messageConditions = {
      0: ' developmental courses',
      one: 'a developmental course',
      other: ' developmental courses'
    };
  }

  numCoursesInSection(): number {
    return _4.flatten(_4.values(this.section._courses_by_group_nk)).length;
  }
  hasCourses(): boolean {
    return !_4.isEmpty(this.section._courses_by_group_nk[this.nk]);
  }
  numPlacementGroups(): number {
    return _4.keys(this.section._courses_by_group_nk).length;
  }
  rotate(degrees: number): any {
    return {
      transform: 'rotate(' + degrees.toString() + 'deg)'
    };
  }

  initializeSectors(): ISector[] {
    const sectorsAll: ISector[] = [];

    angular.forEach(this.graph.bands, (band) => {
      if (band.degrees < -180) {
        sectorsAll.push({
          sectorClipClass: 'clip-l',
          targetClipClass: 'clip-r',
          sectorRotation: 0,
          targetRotation: -180,
          color: band.color
        });
        sectorsAll.push({
          sectorClipClass: 'clip-r',
          targetClipClass: 'clip-l',
          sectorRotation: 0,
          targetRotation: 180 + band.degrees,
          color: band.color
        });
      } else {
        sectorsAll.push({
          sectorClipClass: 'clip-l',
          targetClipClass: 'clip-r',
          sectorRotation: 0,
          targetRotation: band.degrees,
          color: band.color
        });
      }
    });
    return sectorsAll;
  }
  isTestOnPath(test: any): boolean {
    return _4.includes(this.section._tests_on_path, test);
  }
  intMinScore(): number {
    return this.section.next_highest_path_entry_by_group_nk[this.nk]
      ? _4.parseInt(this.section.next_highest_path_entry_by_group_nk[this.nk].min_score)
      : 0;
  }
  getGraphScore(graphs: any, filterFn: any): string {
    const graph = _4.first(_4.filter(graphs, filterFn));
    return !!graph ? this.graph.score : '--';
  }
}

angular.module('biz-ng-path-placement').component('testScoresGraph', {
  bindings: {
    section: '<',
    nk: '<',
    graph: '<'
  },
  controller: TestScoresGraph,
  templateUrl: 'biz-ng-path-placement/src/components/test_score_graph/test_score_graph.html'
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/components/test_score_graph/test_score_graph.ts